export default class FinleapConnectSession {

    constructor()
    {
        this.id = null;
        this.refreshTokenValid = false;
    }

    static fromData(data)
    {
        if (!data) {
            return;
        }

        let finleapConnectSession = new FinleapConnectSession();
        finleapConnectSession.id = data.id;
        finleapConnectSession.refreshTokenValid = data.refreshTokenValid;

        Object.seal(finleapConnectSession);
        return finleapConnectSession;
    }

}
